import { app } from '@/bootloader';

app.config.globalProperties.$global = {};
app.config.globalProperties.$global.gridItemHeight = 25;
